export const formatUrlTrailing = (url: string) =>
	url != undefined && url.match(/\/$/) ? url : url + '/';
